import { render, staticRenderFns } from "./BorrowStatusCard.vue?vue&type=template&id=b8a187f8&scoped=true&"
import script from "./BorrowStatusCard.vue?vue&type=script&lang=js&"
export * from "./BorrowStatusCard.vue?vue&type=script&lang=js&"
import style0 from "./BorrowStatusCard.vue?vue&type=style&index=0&id=b8a187f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a187f8",
  null
  
)

export default component.exports